<template>
    <div>
        <Loading :value="loading" ></Loading>
        <v-layout wrap>
            <!--Formulaire ajout contrat-->
                <v-flex xs12>
                    <v-layout row justify-center>
                        <v-dialog
                                v-model="dialogFormContrat"
                                max-width="70%">
                            <v-card>
                                <v-toolbar dark color="primary">
                                    <v-toolbar-title>Créer un contrat</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-btn icon dark @click="dialogFormContrat = false">
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                </v-toolbar>
                                <v-card-text>
                                    <formContrat :idUserContrat="idUserContrat"  @close="closeFormContrat()"></formContrat>
                                </v-card-text>
                            </v-card>
                        </v-dialog>
                    </v-layout>
                </v-flex>
            <!--Fin Formulaire ajout contrat-->

            <!--Liste contrats-->
                <v-flex xs12>
                    <v-layout wrap>
                        <v-flex xs12>
                            <h4 class="headline" mt-2>Liste des contrats</h4>
                            <v-divider class="mb-3"></v-divider>
                        </v-flex>

                        <v-flex xs12 class="text-xs-right">
                            <v-tooltip bottom>
                                <v-btn v-if="typeAdmin == true"  slot="activator" color="primary" @click="dialogFormContrat = true" >
                                    Créer
                                    <v-icon right dark>add</v-icon>
                                </v-btn>

                                Créer un contrat
                            </v-tooltip>
                        </v-flex>
                         <v-flex xs12 class="text-xs-right">
                            <v-tooltip bottom>
                                <v-btn class="elevation-3" slot="activator" @click="loadContratUser()" dark icon flat color="primary">
                                    <v-icon>cached</v-icon>
                                </v-btn>
                                actualiser la liste
                            </v-tooltip>
                          </v-flex>

                        <v-flex xs12 class="pt-2 pb-2 pl-2 pr-2 mt-1">
                            <!--CONTRATS-->

                            <data-tables :data="listeContrats">
                                <el-table-column type="expand">
                                    <template slot-scope="props">
                                        <v-layout wrap class="elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4">
                                            <v-flex xs12>
                                                <v-layout row>
                                                    <v-flex xs7 mr-3 mt-2>
                                                        <span class="title">Validité contrat</span>
                                                        <v-divider></v-divider>
                                                        <el-table
                                                                :data="props.row.validites"
                                                                stripe
                                                                :row-class-name="tableRowClassName"
                                                                style="width: 100%">
                                                            <el-table-column
                                                                    prop="dateDbt"
                                                                    label="Début"
                                                                    width="180">
                                                            </el-table-column>

                                                            <el-table-column
                                                                    prop="dateFin"
                                                                    label="Fin"
                                                                    width="180">
                                                            </el-table-column>

                                                            <el-table-column
                                                                    prop="infoStatut"
                                                                    label="info">
                                                                <template slot-scope="scope">
                                                                    <el-tag   v-if="scope.row.idStatut == 1"  type="success">{{scope.row.infoStatut}}</el-tag>
                                                                    <el-tag   v-else-if="scope.row.idStatut == 0"  type="danger">{{scope.row.infoStatut}}</el-tag>
                                                                </template>
                                                            </el-table-column>

                                                        </el-table>
                                                    </v-flex>
                                                    <v-flex mr-3 xs5 mt-2>
                                                        <div class="grid-content">
                                                            <p class="title">Contrat créer par: {{props.row.createdUser}} le {{props.row.created}}</p>
                                                            <p class="title">Contrat modifié par: {{props.row.updateUser}} le {{props.row.created}}</p>
                                                        </div>
                                                        <div class="grid-content">
                                                            <el-input
                                                                    type="textarea"
                                                                    :rows="7"
                                                                    :readonly="true"
                                                                    :disabled="true"
                                                                    placeholder="Description du contrat"
                                                                    v-model="props.row.description">
                                                            </el-input>
                                                        </div>
                                                    </v-flex>

                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12>
                                                <v-divider class="mt-4"></v-divider>
                                                <v-layout row>
                                                    <v-flex xs12 class="mr-2 mt-3">
                                                        <div class="grid-content">
                                                            <v-flex xs12>
                                                                <v-layout row wrap >
                                                                    <v-flex xs12 class="text-xs-right">
                                                                        <v-tooltip bottom>
                                                                            <v-btn v-if="typeAdmin"  slot="activator" @click="showAddTaux(props.row.idContrat)"  small  dark color="primary">
                                                                                Ajouter un taux
                                                                            </v-btn>
                                                                            Ajouter un taux
                                                                        </v-tooltip>
                                                                    </v-flex>
                                                                    <v-flex xs12>
                                                                        <span class="title">Taux de paiement</span>
                                                                        <v-divider></v-divider>
                                                                        <el-table
                                                                                :row-class-name="tableRowClassName"
                                                                                :data="props.row.taux"
                                                                                stripe
                                                                                style="width: 100%">
                                                                            <el-table-column
                                                                                    prop="libTauxPaiement"
                                                                                    label="Taux paiement"
                                                                                    width="180">
                                                                            </el-table-column>
                                                                            <el-table-column
                                                                                    prop="libTypePaie"
                                                                                    label="Type paiement"
                                                                                    width="180">
                                                                            </el-table-column>
                                                                            <el-table-column
                                                                                    prop="libStatutTemp"
                                                                                    label="Temps supplémentaire">
                                                                            </el-table-column>

                                                                            <el-table-column
                                                                                    prop="renumeration"
                                                                                    label="Salaire nette">
                                                                                <template slot-scope="scope" >
                                                                                    {{new Intl.NumberFormat().format(scope.row.renumeration)}}
                                                                                </template>
                                                                            </el-table-column>

                                                                            <el-table-column
                                                                                    prop="createdUser"
                                                                                    label="Ajouté par"
                                                                                    width="180">
                                                                            </el-table-column>

                                                                            <el-table-column
                                                                                    prop="created"
                                                                                    label="Créée le"
                                                                                    width="180">
                                                                            </el-table-column>

                                                                            <el-table-column v-if="typeAdmin" prop="Action" label="Action" align="center"  width="100" fixed="right">
                                                                                <template slot-scope="scope" >
                                                                                    <v-tooltip bottom>
                                                                                        <v-btn v-if="scope.row.isDelete == true" @click="showDeleteTaux(scope.row.idTaux)"    slot="activator" flat  icon  color="red">
                                                                                            <v-icon >close</v-icon>
                                                                                        </v-btn>
                                                                                        Supprimer le taux salariale
                                                                                    </v-tooltip>
                                                                                </template>
                                                                            </el-table-column>
                                                                        </el-table>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-flex>
                                                        </div>
                                                    </v-flex>
                                                </v-layout>

                                            </v-flex>
                                        </v-layout>


                                    </template>
                                </el-table-column>

                                <el-table-column prop="idContrat" label="ID-CONTRAT" align="left" >
                                    <template slot-scope="scope" >
                                        CONTRAT-{{scope.row.idContrat}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="dateSign" label="DATE ECHEANCE" align="left"></el-table-column>
                                <el-table-column prop="libTypeContrat" label="TYPE CONTRAT"  align="left"></el-table-column>
                                <el-table-column prop="libEtat" label="STATUT" align="left">
                                    <template slot-scope="scope" >
                                        <el-tag   v-if="scope.row.etat == 4"  type="info">{{scope.row.libEtat}}</el-tag>
                                        <el-tag   v-else-if="scope.row.etat == 0"  type="success">{{scope.row.libEtat}}</el-tag>
                                        <el-tag   v-else-if="scope.row.etat == 3"  type="danger">{{scope.row.libEtat}}</el-tag>
                                        <el-tag   v-else-if="scope.row.etat == 2 "  type="warning">{{scope.row.libEtat}}</el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="projet" label="PROJET" align="left">
                                    <template slot-scope="scope" >
                                        <span class="blue--text body-2">{{scope.row.projet}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="poste" label="POSTE" align="left"></el-table-column>
                                <el-table-column prop="superviseur" label="SUPERVISEUR" align="left"></el-table-column>
                                <el-table-column prop="libTypeContrat" label="TYPE CONTRAT" align="left">
                                    <template slot-scope="scope" >
                                        <span class="orange--text body-2">{{scope.row.libTypeContrat}}</span>
                                    </template>

                                </el-table-column>
                                <el-table-column label="FICHIER" align="center" width="250" fixed="right">
                                    <template slot-scope="scope">
                                        <v-tooltip bottom>
                                        <v-avatar
                                                slot="activator"
                                                v-for="(image, imageIndex) in scope.row.imagesCont"
                                                :key="imageIndex"
                                                @click="showDiapo(scope.row.imagesCont,imageIndex)"
                                                :style="{ backgroundImage: 'url(' + image + ')' , cursor: 'pointer'}"
                                                :tile=true
                                                :size="50"
                                                color="grey lighten-4"
                                                class="mb-1 mr-1 elevation-3"
                                        >
                                            <img :src="image" alt="avatar">
                                        </v-avatar>
                                            Cliquez pour agrandir
                                        </v-tooltip>
                                    </template>
                                </el-table-column>
                            </data-tables>
                        </v-flex>
                    </v-layout>
                </v-flex>
            <!--Liste contrats-->

            <!--Formulaire ajout taux salariale-->
            <v-flex xs12>
                <v-layout row justify-center>
                    <v-dialog
                            v-model="dialogFormAddTaux"
                            max-width="50%">
                        <v-card>
                            <v-toolbar dark color="primary">
                                <v-toolbar-title>Ajouter un taux</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon dark @click="dialogFormAddTaux = false">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text>

                                <el-form label-position="top" ref="formDynamiqueTaux"  :model="formDynamiqueTaux" >
                                    <!--taux de paiement-->
                                    <el-card class="box-card" justify="center">
                                        <el-row justify="center" type="flex" :gutter="20"  v-for="(taux, ind) in formDynamiqueTaux.taux" :key="(taux.ind)" >
                                            <el-col :span="4">
                                                <el-form-item label="Paiement" :prop="'taux.' + ind + '.tauxPaiement'" >
                                                    <el-select v-model="taux.tauxPaiement" placeholder="Taux de paiement">
                                                        <el-option v-for="(item,index) in listeTauxPaiement" :key="index" :label="item.libelle" :value="item.id"></el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>

                                            <el-col :span="4">

                                                <el-form-item label="Type de paie" :prop="'taux.' + ind + '.typePaie'">
                                                    <el-select v-model="taux.typePaie" placeholder="Type de paie">
                                                        <el-option v-for="(item,index) in listeTypePaie" :key="index" :label="item.libelle" :value="item.id"></el-option>
                                                    </el-select>
                                                </el-form-item>

                                            </el-col>

                                            <el-col :span="7">
                                                <el-form-item label="Rénumération" :prop="'taux.' + ind + '.renumeration'">
                                                    <el-input-number v-model="taux.renumeration"  :min="1" ></el-input-number>
                                                </el-form-item>

                                            </el-col>

                                            <el-col :span="5">
                                                <div>
                                                    <el-form-item label="Temps supplémentaire" :prop="'taux.' + ind + '.statut'">
                                                        <el-select v-model="taux.statut" placeholder="Statut de temps">
                                                            <el-option v-for="(item,index) in listeStatut" :key="index" :label="item.libelle" :value="item.id"></el-option>
                                                        </el-select>

                                                    </el-form-item>
                                                </div>
                                            </el-col>

                                            <el-col :span="3">
                                                <div>
                                                    <el-form-item label="." >
                                                        <v-tooltip bottom>
                                                        <v-btn
                                                                slot="activator"
                                                                icon
                                                                flat
                                                                color="red"
                                                                @click="removeTaux(taux)"
                                                        >
                                                            <v-icon>clear</v-icon>

                                                        </v-btn>
                                                            Supprimer
                                                        </v-tooltip>
                                                    </el-form-item>
                                                </div>
                                            </el-col>
                                        </el-row>
                                    </el-card>

                                    <el-row justify="end">
                                        <el-col :span="3" :offset="21">
                                            <div >
                                                <v-tooltip top>
                                                <v-btn
                                                        slot="activator"
                                                        absolute
                                                        right
                                                        top
                                                        dark
                                                        fab
                                                        color="orange"
                                                        @click="addTaux"
                                                >
                                                    <v-icon>add</v-icon>
                                                </v-btn>
                                                    Ajouter une ligne
                                                </v-tooltip>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </el-form>
                            </v-card-text>
                            <v-card-actions class="text-xs-right mt-4">
                                <div style="width:100%" class="mt-4">
                                    <v-tooltip top>
                                    <v-btn
                                            slot="activator"
                                            dark
                                            color="green"
                                            @click="submitFormTaux('formDynamiqueTaux')"
                                    >

                                        Enregistrer
                                        <v-icon right>save</v-icon>
                                    </v-btn>
                                        enregistrer les taux
                                    </v-tooltip>
                                </div>

                            </v-card-actions>

                        </v-card>
                    </v-dialog>
                </v-layout>
            </v-flex>
            <!--Fin Formulaire ajout taux salarial-->

            <!--DIALOG SUPPRESSION TAUX DE SALAIRE-->
            <v-dialog
                    v-model="dialogSuppTaux"
                    max-width="350"
            >
                <v-card>
                    <v-card-title class="headline">

                        <el-alert
                                :title="'Voulez-vous supprimer cet enregistrement ?'"
                                type="warning"
                                :closable="false"
                                show-icon>
                        </el-alert>
                    </v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn
                                color="green darken-1"
                                flat="flat"
                                @click="dialogSuppTaux = false"
                        >
                            Non
                        </v-btn>

                        <v-btn
                                color="red darken-1"
                                flat="flat"
                                @click="submitDeleteTaux()"
                        >
                            Oui
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <CoolLightBox
                    :items="items"
                    :index="index"
                    @close="index = null"
            >

            </CoolLightBox>

        </v-layout>

    </div>
</template>

<script>
    import Loading from '@/components/Loading';
    import FormContrat from '@/components/resourceHumaine/form_contrat'

    export default {
        props:{
            idUserContrat: {
                type: Number
            },
            typeAdmin: {
                type: Boolean,
                default: true,
            }
        },
        components: {Loading,FormContrat},
        name: "contratEmploye",
        data(){
            return {
                notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
                loading: false,


                dialogFormContrat: false,
                dialogFormAddTaux: false,
                dialogSuppTaux: false,
                formDynamiqueTaux: {
                    taux :[
                        {
                            key:  1,
                            tauxPaiement: 1,
                            typePaie: 1,
                            renumeration: 5,
                            statut: 0,
                        }
                    ]
                },
                listeContrats:[],
                listeStatut:[
                    {
                        libelle: "non",
                        id: 0
                    },
                    {
                        libelle: "exempt",
                        id: 1
                    },

                ],
                listeTauxPaiement:[
                    {
                        libelle: "Heure",
                        id: 1
                    },
                    {
                        libelle: "Mois",
                        id: 2
                    },
                    {
                        libelle: "Semaine",
                        id: 3
                    },
                    {
                        libelle: "Annee",
                        id: 4
                    },
                ],
                listeTypePaie:[
                    {
                        libelle: "Salaire",
                        id: 1
                    },
                    {
                        libelle: "Heure",
                        id: 2
                    },
                    {
                        libelle: "Contrat",
                        id: 3
                    },
                    {
                        libelle: "Commission",
                        id: 4
                    },
                ],
                contratSelect: null,
                tauxSelect: null,
                items: [],
                index: null

            }
        },
        methods:{
            showDiapo(images, ind){
                this.items = images
                this.index = ind;
            },
            tableRowClassName({row, rowIndex}) {
                if (rowIndex === 1) {
                    return 'warning-row';
                } else if (rowIndex === 3) {
                    return 'success-row';
                }
                return '';
            },
            loadContratUser()
            {
                this.loading = true;
                let url = this.domaine + "rh/contrat/employe/"+this.idUserContrat;

                this.$http.get(url).then(resp =>{
                    this.loading = false;
                    this.listeContrats = resp.body.listeContrats;
                }, error =>{
                    this.loading = false;
                    this.$message.error("Echec lors du chargement des contrats de l'employé ")
                });

            },
            showDeleteTaux(idTaux){
                this.dialogSuppTaux = true;
                this.tauxSelect = idTaux;
            },
            submitDeleteTaux(){
                this.loading = true;
                let url = this.domaine+"rh/taux/"+this.tauxSelect+"/delete"
                this.$http.get(url).then(resp=>{
                    this.loading = false;
                    this.dialogSuppTaux = false;
                    this.successNotif(resp.body.message)
                    this.tauxSelect = null;
                    this.loadContratUser();
                }, error=>{
                    this.loading = false;
                    this.dialogSuppDetail = false;
                    this.$message.error("Echec lors de la suppression du taux salarial")
                })
            },

            submitFormTaux(formName){
                this.$refs[formName].validate((valid) => {
                    if (!valid) {
                        alert('submit!');
                        return;
                    }

                    this.loading = true;
                    let url = this.domaine + "rh/contrat/" +this.contratSelect+"/taux";
                    let data = new FormData();
                    data.append("listeTaux", JSON.stringify(this.formDynamiqueTaux.taux));
                    data.append("userCreated", this.user.id)

                    this.$http.post(url,data).then(resp=>{
                        this.loading = false;
                        this.dialogFormAddTaux = false;
                        this.contratSelect = null;
                        this.loadContratUser()
                        this.successNotif(resp.body.message)
                    }, error=>{
                        this.loading = false;
                        this.contratSelect = null;
                        this.$message.error("Echec lors de l'enregistrement du taux")
                    })



                });
            },
            successNotif(mess = ""){
                this.$notify({
                    title: 'ENREGISTREMENT REUSSI',
                    message: mess,
                    type: 'success',
                    position: 'top-center'
                })
            },

            showAddTaux(contratSel){
                this.dialogFormAddTaux = true;
                this.contratSelect = contratSel;
            },

            removeTaux(item) {
                var index = this.formDynamiqueTaux.taux.indexOf(item);
                if (index !== -1) {
                    this.formDynamiqueTaux.taux.splice(index, 1);
                }
            },

            addTaux() {
                this.formDynamiqueTaux.taux.push(
                    {
                        key: 44666,
                        tauxPaiement: 1,
                        typePaie: 1,
                        renumeration: 5,
                        statut: 0,
                    }
                );
            },




            closeFormContrat(){
                this.dialogFormContrat = false
                this.loadContratUser()
            }
        },
        watch:{
            idUserContrat: function(newValue, oldValue){
                if(newValue != 0){
                    this.loadContratUser()
                }
            }
        },
        mounted()
        {
           //this.loadContratUser()
        }
    }

</script>

<style>
    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }
</style>



// WEBPACK FOOTER //
// src/components/resourceHumaine/contrat_employe.vue